import { DialogComponent } from '@theme/dialog';

export class DrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    
    const dialog = this.refs.dialog;
    if (dialog && !dialog.classList.contains('why-design-drawer--closed')) {
      dialog.classList.add('why-design-drawer--closed');
    }
    
    if (dialog) {
      dialog.addEventListener('click', this.#handleDialogClick.bind(this));
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    
    const dialog = this.refs.dialog;
    if (dialog) {
      dialog.removeEventListener('click', this.#handleDialogClick.bind(this));
    }
  }

  /**
   * Handle dialog clicks - close on backdrop click
   * @param {MouseEvent} event
   */
  #handleDialogClick(event) {
    const dialog = this.refs.dialog;
    if (!dialog) return;

    if (event.target === dialog) {
      this.close();
    }
  }

  open() {
    const dialog = this.refs.dialog;
    if (!dialog) {
      console.error('DrawerComponent: dialog ref not found');
      return;
    }
    
    if (!dialog.open) {
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    }
    
    dialog.classList.remove('why-design-drawer--closed');
  }

  close() {
    const dialog = this.refs.dialog;
    if (!dialog) {
      console.error('DrawerComponent: dialog ref not found');
      return;
    }
    
    dialog.classList.add('why-design-drawer--closed');
    
    setTimeout(() => {
      if (dialog.open) {
        dialog.close();
        document.body.style.overflow = '';
      }
    }, 300);
  }
}

if (!customElements.get('drawer-component')) {
  customElements.define('drawer-component', DrawerComponent);
}
